import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-data-processing-agreement',
  imports: [TranslateModule],
  templateUrl: './data-processing-agreement.component.html',
  styleUrl: './data-processing-agreement.component.scss',
})
export class DataProcessingAgreementComponent {

}
